<template>
  <div class="china-datasource-select">
    <div
      v-for="(item, index) in list"
      :key="index"
      :class="item.active ? 'item active' : 'item'"
      :style="(index > 0 && index < list.length - 1) ? 'border-left: none; border-right: none' : ''"
      @click="onClick(item)"
    >{{item.name}}</div>
  </div>
</template>

<script>
export default {
  name: "ChinaDataSourceSelect",
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    click(name) {
      const item = this.list.find(e => e.name === name);
      if (item) {
        this.onClick(item);
      }
    },
    onClick(e) {
      this.list.forEach(e => (e.active = false));
      e.active = true;
      this.active = e.name;
      this.$emit("change", e);
    }
  }
};
</script>

<style lang="scss">
.china-datasource-select {
  width: 240px;
  .item {
    width: 78px;
    height: 28px;
    display: inline-block;
    border: 1px solid #848791;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;

    color: #848791;
    background: #ffffff;
  }
  .active {
    color: #ffffff;
    background: #848791;
  }
}
</style>